export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-white mb-4">移动端随时随地吃瓜</h2>
            <p className="text-white/80 leading-relaxed mb-6">
              91吃瓜移动客户端现已支持 iOS 与 Android 双平台。
              高清流畅播放，离线缓存功能让你在地铁、高铁上也能畅享精彩视频。
              推送提醒不错过任何热门爆料，赶快下载体验吧。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="flex-1 max-w-[380px]">
            <div className="relative aspect-[9/16] rounded-2xl overflow-hidden bg-background-950/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20dark%20theme%2C%20video%20thumbnails%20in%20grid%20layout%2C%20trending%20content%20badges%20in%20warm%20coral%20and%20amber%20colors%2C%20clean%20minimal%20UI%20design%2C%20floating%20perspective%20angle%2C%20soft%20studio%20lighting%2C%20isolated%20on%20transparent%20background&width=600&height=1067&seq=app-mockup-91cg&orientation=portrait"
                alt="91吃瓜移动端应用界面"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}